<mat-dialog-content class="estupefaciente-modal-container">
  <h3 class="title">
    <ng-container *ngIf="drugCodeControl.value && medicineName; else defaultTitle">
      {{ drugCodeControl.value }} - {{ medicineName }}
    </ng-container>
    <ng-template #defaultTitle>Estupefaciente</ng-template>
  </h3>
  <div class="content">
    <p class="description">Indique la cantidad de unidades de medicamento (1 a 4) y opcionalmente, su código nacional.</p>
    <div class="form-row">
      <span class="form-label">Cantidad</span>
      <app-form-field
        class="field"
        type="number"
        placeholder="0"
        [fieldControl]="qtyControl"
      ></app-form-field>
    </div>
    <div class="form-row" (focusout)="onCodeBlur()">
      <span class="form-label">Código</span>
      <app-form-field
        class="field"
        type="text"
        placeholder="Código nacional"
        [fieldControl]="drugCodeControl"
      ></app-form-field>
    </div>
    <div class="form-row" *ngIf="medicineName">
      <span class="form-label">Nombre</span>
      <span class="medicine-name">{{ medicineName }}</span>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="center" class="estupefaciente-modal-buttons">
  <button
    mat-raised-button
    color="primary"
    tabindex="1"
    (click)="onConfirmClick()"
  >
    Aceptar
  </button>
  <button
    mat-raised-button
    mat-dialog-close
    tabindex="-1"
  >
    Cancelar
  </button>
  <button
    mat-raised-button
    tabindex="-1"
    (click)="onClearClick()"
  >
    Limpiar datos
  </button>
</mat-dialog-actions>
